import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { AdditionalBenefitListItemsExtensionInterface } from '../../../extension/interface/additional-benefit-list-items.extension.interface';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { CouponsBenefitListItemExtension } from './coupons-benefit-list-item.extension';
import { CouponsBenefitMetadataExtension } from './coupons-benefit-metadata.extension';
import { CouponsStandaloneAdditionalItemsExtension } from './coupons-standalone-additional-items.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('coupons')
    .add(BenefitMetadataExtensionInterface, new CouponsBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new CouponsBenefitListItemExtension())
    .add(AdditionalBenefitListItemsExtensionInterface, new CouponsStandaloneAdditionalItemsExtension())
    .build(),
);
